(function ($, Drupal) {
   'use strict';

  Drupal.behaviors.bookMenu = {
    attach: function(context, settings) {
      once('mobile-suite-menu-toggle', 'html').forEach(function (element) {
        $('#mobile-suite-menu-toggle').on('click.bookMenu', function(event) {
          $('#mobile-suite-menu-toggle').toggleClass('open');
          $('#mobile-suite-menu').toggleClass('open');
          $('#mobile-suite-menu').attr('aria-hidden', (index, aria) => (aria == false ? true : false));
        });
      });
    },
    attach: function(context, settings) {
      once('.intra-nav-menu .intra-nav-menu-item a').on('click.bookLink', function (element) {
      	$('#mobile-suite-menu').toggleClass('open');
      	$('#mobile-suite-menu').attr('aria-hidden', (index, aria) => (aria == false ? true : false));
      });
    }
  };
})(jQuery, Drupal);
